var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page-section', {
    staticClass: "page-section--first page-section--sm"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "9"
    }
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v(" 리본바이옴, "), _c('br'), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("식물성유산균으로 미래")]), _vm._v("를 만듭니다. ")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "tit tit--sm font-weight-medium line-height-15"
  }, [_vm._v(" 식물성유산균을 기반으로, "), _c('br'), _vm._v(" 더 나은 삶을 위한 솔루션을 만듭니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "txt txt--lg line-height-15"
  }, [_vm._v(" ㈜웰빙엘에스는 장류·김치 등 발효 식품에서 특허받은 식물성유산균 기술을 바탕으로 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 프리·프로·포스트바이오틱스 분야를 선도하는 미생물 전문기업입니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" ㈜리본바이옴은 이러한 웰빙엘에스의 기술력을 기반으로, 온·오프라인 유통, 파트너십 지원, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 글로벌 세일즈를 전담하며 제조와 판매의 시너지를 통해 더 나은 삶을 위한 건강 솔루션을 제안합니다. ")])])], 1)], 1), _c('v-col', {
    staticClass: "d-none d-lg-block",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-img', {
    staticClass: "ceo-image",
    attrs: {
      "src": "/images/about/ceo.png",
      "alt": ""
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }